import "./App.css";
import { Flex, Button, Image, Box } from "@chakra-ui/react";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { MAIN, MAIN_BACKGROUND } from "./colours";

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleContactClick = () => {
    const element = document.getElementById("GET IN TOUCH");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/#contact");
      setTimeout(() => {
        const el = document.getElementById("GET IN TOUCH");
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };

  return (
    <Flex
      h="10vh"
      justifyContent={"space-between"}
      alignItems={"center"}
      bgColor={MAIN_BACKGROUND}
      px="8"
      py="20"
    >
      <Link to="/">
        <Image src="/logo.png" alt="logo" height={250} pt="16" />
      </Link>
      <Flex
        alignItems={"center"}
        fontSize={"40px"}
        color={MAIN}
        direction={{ base: "column", lg: "row" }}
      >
        <FaInstagram
          cursor={"pointer"}
          onClick={() =>
            window.open("https://www.instagram.com/happyfigfoods/?hl=en")
          }
        />
        <Box ml={{ base: "0", lg: "8" }} mt={{ base: "4", lg: "0" }}>
          <FaWhatsapp
            cursor={"pointer"}
            onClick={() => window.open("https://wa.me/447415455260")}
          />
        </Box>
        <Button
          as={Link}
          to={location.pathname === "/" ? "/about" : "/"}
          size="lg"
          bg="transparent"
          color={MAIN}
          ml="14"
          display={{ base: "none", md: "flex" }}
          alignItems="center"
          justifyContent="center"
          border={`2px solid ${MAIN}`}
          borderRadius={"none"}
          _hover={{ bg: MAIN, color: MAIN_BACKGROUND }}
        >
          {location.pathname === "/" ? "About" : "Home"}
        </Button>
        <Button
          size="lg"
          bg={MAIN}
          color={MAIN_BACKGROUND}
          ml="4"
          display={{ base: "none", md: "block" }}
          border={`2px solid ${MAIN}`}
          borderRadius={"none"}
          _hover={{ bg: "transparent", color: MAIN }}
          onClick={handleContactClick}
        >
          Contact us
        </Button>
      </Flex>
    </Flex>
  );
}
